import { createFileRoute } from '@tanstack/react-router';

import { FirstCallDashboard } from '../modules/ComponentsLibrary/First-Calls';

export const Route = createFileRoute('/first-calls')({
  component: RouteComponent,
});

function RouteComponent() {
  return <FirstCallDashboard />;
}
